import React from "react";
import NewChat from "./NewChat";
import ActiveChat from "./ActiveChat";
import ChatInput from "../components/ChatInput";
import { useOutletContext } from "react-router-dom";
import Header from "../components/Header";
import { useParams } from "react-router-dom";

const Main = () => {
  const {
    chatList,
    newChat,
    prompt,
    setPrompt,
    isFetchingResponse,
    setPreviousMessages,
    previousMessages,
    userQueryAndReport,
    handleSend,
    stopFetchingResponse,
    brandChangeHandler,
    setDashboards,
    activeChat,
  } = useOutletContext();

  const { chatId } = useParams();
  return (
    <>
      <Header brandChangeHandler={brandChangeHandler} />
      <div className="mx-auto w-full flex-1 flex flex-col overflow-auto">
        {(chatList.length === 0 || newChat) && !chatId ? (
          <NewChat setPrompt={setPrompt} />
        ) : (
          <ActiveChat
            activeChat={chatId || activeChat}
            isFetchingResponse={isFetchingResponse}
            setPreviousMessages={setPreviousMessages}
            previousMessages={previousMessages}
            userQueryAndReport={userQueryAndReport}
            setDashboards={setDashboards}
          />
        )}
        <ChatInput
          prompt={prompt}
          isFetchingResponse={isFetchingResponse}
          setPrompt={setPrompt}
          handleSend={handleSend}
          stopFetchingResponse={stopFetchingResponse}
        />
      </div>
    </>
  );
};

export default Main;
